'use client';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { EmailViewerProps } from './email-viewer-types';
import { EmailHeader } from './email-header';
import { EmailBody } from './email-body';
import { EmailAttachment } from './email-attachment';
import ExtractedDataTab from './ExtractedDataTab';
import OCRResultsTab from './OCRResultsTab';
import { Separator } from '@/components/ui/separator';

const hideDataTabs = true;

export function EmailViewerV2({
  emailData,
  fetchExtractedPurchaseOrder,
  fetchOCR,
  defaultTab = 'email',
}: EmailViewerProps) {
  const hasAttachments = !!emailData.attachments?.length;

  const showOCRTab = !!fetchOCR && !!emailData.inboundEmailId;
  const showExtractedDataTab =
    !!fetchExtractedPurchaseOrder && !!emailData.inboundEmailId;

  return (
    <div className="h-full overflow-y-scroll">
      <Tabs defaultValue={defaultTab} className="h-full">
        <div className="p-1 sticky top-0 bg-background">
          <TabsList className="w-full">
            <TabsTrigger value="email">Email</TabsTrigger>
            <TabsTrigger value="attachments">
              Attachments ({emailData.attachments?.length || 0})
            </TabsTrigger>
            {showOCRTab && !hideDataTabs && (
              <TabsTrigger value="ocr">OCR</TabsTrigger>
            )}
            {showExtractedDataTab && !hideDataTabs && (
              <TabsTrigger value="extracted-data">Extracted Data</TabsTrigger>
            )}
          </TabsList>
        </div>

        <Separator />

        <TabsContent value="email">
          <div className="flex flex-col gap-1">
            <EmailHeader emailData={emailData} />
            <EmailBody emailData={emailData} />
          </div>
        </TabsContent>

        <TabsContent value="attachments">
          <EmailAttachment emailData={emailData} />
        </TabsContent>

        {showOCRTab && !hideDataTabs && (
          <TabsContent value="ocr">
            <OCRResultsTab
              inboundEmailId={emailData.inboundEmailId}
              attachments={emailData.attachments}
            />
          </TabsContent>
        )}

        {showExtractedDataTab && !hideDataTabs && (
          <TabsContent value="extracted-data">
            <ExtractedDataTab
              inboundEmailId={emailData.inboundEmailId}
              hasAttachments={hasAttachments}
            />
          </TabsContent>
        )}
      </Tabs>
    </div>
  );
}
